import { Images } from 'lucide-react';
import { BACKEND_URL } from '../../lib/constants';

const FALLBACK =
  'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="200"%3E%3Crect fill="%23181B26" width="200" height="200"/%3E%3Ctext fill="%2364748B" font-family="monospace" font-size="12" x="50%25" y="50%25" dominant-baseline="middle" text-anchor="middle"%3ENO PREVIEW%3C/text%3E%3C/svg%3E';

export const PhotosGrid = ({ images }) => (
  <div className="card p-6" data-testid="photos-card">
    <div className="mb-6">
      <h2 className="h-display text-lg">Uploaded photos</h2>
      <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500 mt-1">{images.length} in this workspace</p>
    </div>
    {images.length > 0 ? (
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
        {images.map((image, index) => (
          <div key={image.id} className="group border border-line rounded-2xl overflow-hidden hover:border-cyan bg-white transition-colors" data-testid={`image-card-${index}`}>
            <div className="relative aspect-square bg-panel overflow-hidden border-b border-line">
              <img
                src={`${BACKEND_URL}/api/image/admin/${image.id}`}
                alt={image.filename}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                onError={(e) => { e.target.src = FALLBACK; }}
              />
              <span className={`absolute top-2 left-2 ${image.processed ? 'badge-success' : 'badge-warning'} !bg-white/95`}>
                {image.processed ? 'Processed' : 'Pending'}
              </span>
            </div>
            <div className="p-2.5 flex items-center justify-between gap-2">
              <div className="min-w-0"><p className="font-mono text-[11px] text-slate-400 truncate" title={image.filename}>{image.filename}</p>{image.uploaded_by && <p className="font-mono text-[10px] text-slate-600 truncate">by {image.uploaded_by}</p>}</div>
              {image.user_matches?.length > 0 && (
                <span className="shrink-0 font-mono text-[10px] font-bold text-cyan border border-cyan px-1.5 py-0.5">
                  {image.user_matches.length}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    ) : (
      <div className="py-14 text-center border-2 border-dashed border-line" data-testid="no-photos">
        <Images className="w-8 h-8 text-slate-600 mx-auto mb-3" />
        <p className="font-display font-bold uppercase tracking-wider text-sm text-slate-300">No photos uploaded yet</p>
        <p className="text-xs text-slate-500 mt-1">Head to Overview to upload your event album.</p>
      </div>
    )}
  </div>
);
